export default "__VITE_ASSET__CLymXI1v__"